import _ from 'lodash'

const eventHandlers = {}

const setElement = (trigger, openIt, containerElement) => {
  if(trigger) {
    trigger.setAttribute('aria-expanded', !!openIt)

    const content = containerElement.querySelector(`#${trigger.getAttribute('aria-controls')}`)
    content.setAttribute('aria-hidden', !openIt)
  }
}

const tabCallback = function(tabTriggers, containerElement) {
  if (this.getAttribute('aria-expanded') !== 'true') {
    resetAll(tabTriggers, containerElement)
    setElement(this, true, containerElement)
  }
}

const resetAll = (tabTriggers, containerElement) => {
  _.forEach(tabTriggers, trigger => {
    setElement(trigger, false, containerElement)
  })
}

const registerEventHandlers = (containerElement, tabTriggers) => {
  return _.map(tabTriggers, element => {
    const callback = _.partial(tabCallback, tabTriggers, containerElement)
    element.addEventListener('click', callback)
    return { element, callback }
  })
}

const directive = {
  bind(containerElement) {
    const tabTriggers = containerElement.querySelectorAll('.js-tab-trigger')
    if (tabTriggers.lenght === 0) {
      return
    }

    const firstTrigger = tabTriggers.item(0)
    setElement(firstTrigger, true, containerElement)

    eventHandlers[containerElement] = registerEventHandlers(containerElement, tabTriggers)
  },
  unbind(containerElement) {
    _.forEach(eventHandlers[containerElement], ({ element, callback }) => {
      element.removeEventListener('click', callback)
    })
  }
}

export default directive
